import React from 'react';
import data from '../../programs.json';

const { programsOverview } = data;

const ProgramsOverview = () => {
  const { id, heading, items } = programsOverview;

  return (
    <section id={id} className="w-full bg-white ava-section-gap">
      <div className="container mx-auto px-4 md:px-8">

        {/* ── Section Heading ── */}
        <h2
          className="ava-heading-gap ava-heading-md"
        >
          {heading}
        </h2>

        {/* ── 3-column grid ── */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((item) => (
            <ProgramCard key={item.id} item={item} />
          ))}
        </div>

      </div>
    </section>
  );
};

const ProgramCard = ({ item }) => (
  <div className="flex flex-col overflow-hidden ava-card-bg ava-card-mukta ava-radius-md " style={{ minHeight: '350px' }}>

    {/* Image with title banner overlay */}
    <div
      className="relative w-full flex-shrink-0 overflow-hidden"
      style={{ height: 'clamp(140px, 18vw, 200px)' }}
    >
      <img
        src={item.image}
        alt={item.title}
        className="w-full h-full object-cover object-center"
        draggable={false}
      />
      {/* Title banner overlaid at top of image */}
      <div
        className="absolute top-0 left-0 px-3 py-2 ava-card-bg"
        style={{
          // backgroundColor: '#fff6ea',
          // color: '#1E4FCC',
          borderRadius: '0px 0px 8px 8px'   // top-left, top-right, bottom-right, bottom-left
        }}
      >
        <span
          className="ava-text-subheading  whitespace-nowrap"
          // style={{ fontSize: 'clamp(0.8rem, 1.4vw, 0.95rem)' }}
        >
          {item.title}
        </span>
      </div>
    </div>

    {/* Content below image */}
    <div className="flex flex-col gap-3 px-5 py-4 flex-1">
      <p className="ava-text-body ">
        {item.description}
      </p>
      <div>
        <a
          href={item.href}
          // className="inline-block text-white text-sm font-semibold px-5 py-2 rounded-md transition-opacity duration-200 hover:opacity-90"
          className='btn-transparent'
          style={{
             backgroundColor: 'var(--primary-color)',  color: 'white' }}
        >
          Enroll Now
        </a>
      </div>
    </div>

  </div>
);

export default ProgramsOverview;